// Helpers for building FAQPage schema from slot vnodes. Working from vnodes rather
// than the rendered DOM means it runs during SSR/static generation, so the schema is
// in the HTML for crawlers that don't run JavaScript.

// Plain text of a list of vnodes (text nodes, elements and component children)
export function vnodeText(vnodes) {
  return (vnodes || []).map((vnode) => {
    if (vnode.text) return vnode.text
    if (vnode.componentOptions) return vnodeText(vnode.componentOptions.children)
    return vnodeText(vnode.children)
  }).join('')
}

// Find every FAQ component (anything with a `question` prop, e.g. <BlocksFaq>) in a
// list of slot vnodes. WordPress can wrap shortcodes in <p> tags, so look inside plain
// elements too, but not inside an FAQ itself. Returns [{ question, answer }].
export function findFaqs(vnodes, found = []) {
  (vnodes || []).forEach((vnode) => {
    const props = vnode.componentOptions && vnode.componentOptions.propsData
    if (props && props.question) {
      found.push({
        question: props.question,
        answer: vnodeText(vnode.componentOptions.children)
      })
    } else if (vnode.children) {
      findFaqs(vnode.children, found)
    }
  })
  return found
}

export function cleanText(str) {
  return String(str || '').replace(/\s+/g, ' ').trim()
}

// [{ question, answer }] -> FAQPage schema, skipping incomplete pairs and duplicate
// questions. Returns null if there's nothing to output.
export function buildFaqPageSchema(items) {
  const seen = new Set()
  const mainEntity = []
  items.forEach((item) => {
    const question = cleanText(item.question)
    const answer = cleanText(item.answer)
    if (!question || !answer || seen.has(question)) return
    seen.add(question)
    mainEntity.push({
      "@type": "Question",
      "name": question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": answer
      }
    })
  })
  if (!mainEntity.length) return null
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity
  }
}
